/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_External_CollaboratorsInputs */

const fr_auth_external_collaborators = /** @type {(inputs: Auth_External_CollaboratorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les collaborateurs externes se connectent avec l’invitation envoyée à leur adresse e-mail.`)
};

const en_auth_external_collaborators = /** @type {(inputs: Auth_External_CollaboratorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External collaborators sign in with the invitation sent to their email address.`)
};

/**
* | output |
* | --- |
* | "External collaborators sign in with the invitation sent to their email address." |
*
* @param {Auth_External_CollaboratorsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_external_collaborators = /** @type {((inputs?: Auth_External_CollaboratorsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_External_CollaboratorsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_external_collaborators(inputs)
	return fr_auth_external_collaborators(inputs)
});